import React, { useContext } from "react";
import { PciDashboardSummaryType } from "@app/projects/network-assessment/pci-dashboard/shared";
import { ClaimsInsightsDashboardContext } from "@app/projects/network-assessment/pci-dashboard/claims-insights/ClaimsInsightsDashboardContext";
import ClaimsInsightsProviderScenarioTile from "@app/projects/network-assessment/pci-dashboard/claims-insights/ClaimsInsightsProviderScenarioTile";
import { ClaimsInsightsRankingRequestTypeEnum } from "@app/projects/network-assessment/pci-dashboard/claims-insights/ClaimsInsightsRankingRequestTypeEnum";
import ClaimsInsightsSummaryScenarioTile from "@app/projects/network-assessment/pci-dashboard/claims-insights/ClaimsInsightsSummaryScenarioTile";

export const ClaimsInsightsDashboardScenarioView: React.FC<React.PropsWithChildren<unknown>> = () => {
  const claimsInsightsContext = useContext(ClaimsInsightsDashboardContext);

  return (
    <React.Fragment>
      <div className="row">
        <ClaimsInsightsProviderScenarioTile
          data={claimsInsightsContext.networkProviderScenarioEffectivenessScores}
          loading={claimsInsightsContext.networkProviderScenarioEffectivenessScoresLoading}
          onProviderScenarioDashboardDetailsViewClick={claimsInsightsContext.onDashboardDetailsViewClick}
          rankingRequestType={ClaimsInsightsRankingRequestTypeEnum.Effectiveness}
        />
        <ClaimsInsightsProviderScenarioTile
          data={claimsInsightsContext.networkProviderScenarioEfficiencyScores}
          loading={claimsInsightsContext.networkProviderScenarioEfficiencyScoresLoading}
          onProviderScenarioDashboardDetailsViewClick={claimsInsightsContext.onDashboardDetailsViewClick}
          rankingRequestType={ClaimsInsightsRankingRequestTypeEnum.Efficiency}
        />
      </div>
      <div className="row">
        <ClaimsInsightsSummaryScenarioTile
          getSummaries={claimsInsightsContext.getScenarioSummaries}
          loading={claimsInsightsContext.countyScenarioSummariesLoading}
          onSummaryDashboardDetailsViewClick={claimsInsightsContext.onSummaryDashboardDetailsViewClick}
          scenarioModel={claimsInsightsContext.countyScenarioSummariesModel}
          summaryType={PciDashboardSummaryType.County}
        />
      </div>
      <div className="row">
        <ClaimsInsightsSummaryScenarioTile
          getSummaries={claimsInsightsContext.getScenarioSummaries}
          loading={claimsInsightsContext.specialtyScenarioSummariesLoading}
          onSummaryDashboardDetailsViewClick={claimsInsightsContext.onSummaryDashboardDetailsViewClick}
          scenarioModel={claimsInsightsContext.specialtyScenarioSummariesModel}
          summaryType={PciDashboardSummaryType.Specialty}
        />
      </div>
    </React.Fragment>
  );
}

export default ClaimsInsightsDashboardScenarioView;
